export class Roles {
    roles = {
        USER: 1,
    };
    role = 'USER';

    constructor() {}

    getRole() {
        return this.role;
    }
}



// WEBPACK FOOTER //
// ./src/app/acl/roles.ts